import React from "react";
import { ArrowRight, CalendarDays } from "lucide-react";
import { blogPosts } from "../../mock";
import Reveal from "../Reveal";

export default function BlogSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">Insights</p>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0b1f3a] mt-3">
              Financing News &amp; Tips
            </h2>
          </div>
          <a href="#" className="inline-flex items-center gap-2 text-sm font-semibold text-[#0b1f3a] hover:text-[#b08e46] transition">
            View All Posts <ArrowRight className="h-4 w-4" />
          </a>
        </Reveal>

        <div className="mt-12 grid gap-7 md:grid-cols-3">
          {blogPosts.map((post, i) => (
            <Reveal key={post.title} delay={i * 100}>
              <article className="group h-full rounded-2xl ring-1 ring-slate-100 p-7 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="flex items-center gap-2 text-xs font-medium text-slate-500">
                  <CalendarDays className="h-4 w-4 text-[#c6a15b]" />
                  {post.date}
                </div>
                <h3 className="font-display font-bold text-lg text-[#0b1f3a] mt-4 group-hover:text-[#b08e46] transition-colors">
                  {post.title}
                </h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{post.excerpt}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#c6a15b]">
                  Read More <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
